export default {
	idForm: null,
	idPage: null,
	idCounter: null,
	idDependence: null,
	questionsByPage: [],
	allPages: [],
	counter: 0,
	actiePopupDependence: false,
	activePopupChoice: false,
	activePopupFlex: false,
	indexQuestionSetting: null,
	optionsDependencies: [],
	saveCreatedDependecies: {},

	AllQuestions: [], //para el flex

	disabledGroup: false,
	dataSidebar: {
		nameForm: '',
		grupo: '',
		isSubForm: '0',
		version: 1,
        formID: '',
        companyID: ''
	},

	//=================================================
	listSubFormularios: [],
	listOrigins: [],

	//=================================================
	componentPopup: '',
	activePopup: false,
	indexQuestion: 0,

	//=================================================
	clickNotClose: true,
	isFilterSidebarActive: true
}









